import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'canTranslateForAttr',
  standalone: true
})
export class CanTranslateForAttrPipe implements PipeTransform {

  transform(lang: string): string {
    return lang ? '' : 'no';
  }
}
